import {
  DvTextCellEditor,
  DvToolbarAction,
  DvToolbarActionEvent,
} from '@devinco/ui/grid';
import { Injectable, inject } from '@angular/core';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { getStandardActionPreset } from '@features/vt-grid/presets/preset-actions';
import { AttachmentsService } from '@shared/services/attachments.service';
import { ColDef, IRowNode } from 'ag-grid-community';
import { take, tap } from 'rxjs';
import { VehicleAttachmentDto } from './interfaces';

@Injectable({ providedIn: 'root' })
export class VehiclePictureDocumentGridService {
  private attachmentsService = inject(AttachmentsService);

  getColumnDefs(
    radioButtonChangeFn: (selectedNodeId?: number) => void,
    isEditEnabledFn: () => boolean
  ): ColDef<VehicleAttachmentDto>[] {
    return [
      {
        headerName: 'Grid.Id',
        type: [ColumnType.Id],
        field: 'DocumentID',
        hide: true,
      },
      {
        headerName: 'PictureDocumentGrid.IsDefault',
        field: 'IsDefault',
        type: [ColumnType.RadioButton],
        width: 100,
        flex: 2,
        cellRendererParams: {
          disabledFn: (node?: IRowNode<VehicleAttachmentDto>) =>
            !isEditEnabledFn() ||
            !this.attachmentsService.isImage(node?.data?.FileName),
          check: (node: IRowNode<VehicleAttachmentDto>) => {
            if (!node.data?.IsDefault) {
              node.setDataValue('IsDefault', true);
              radioButtonChangeFn(node.data?.DocumentID);
            }
          },
          unCheck: (node: IRowNode<VehicleAttachmentDto>) => {
            if (node.data?.IsDefault) {
              node.setDataValue('IsDefault', false);
            }
          },
          filter: 'agSetColumnFilter',
        },
      },
      {
        headerName: 'PictureDocumentGrid.DocumentThumbnail',
        field: 'DocumentThumbnail',
        type: [ColumnType.Thumbnail],
        enableRowGroup: false,
        width: 100,
        flex: 4,
      },
      {
        headerName: 'PictureDocumentGrid.DocumentDescription',
        field: 'DocumentDescription',
        type: [ColumnType.Text],
        cellEditor: DvTextCellEditor,
        editable: true,
      },
      {
        field: 'CreatedTime',
        headerName: 'PictureDocumentGrid.CreatedTime',
        type: [ColumnType.DateTime],
      },
      {
        headerName: 'PictureDocumentGrid.DocumentFileName',
        field: 'FileName',
        type: [ColumnType.Text],
        flex: 4,
      },
    ];
  }

  getToolbarActions(
    uploadFileFn: () => void,
    deleteFileFn: (event?: DvToolbarActionEvent) => void
  ): DvToolbarAction[] {
    return [
      ...getStandardActionPreset(),
      {},
      {
        icon: 'download',
        tooltipKey: 'Grid.Download',
        clickFn: ({ api }) => {
          this.attachmentsService
            .getAttachmentUrl(api.getSelectedNodes()[0].data.DocumentID, false)
            .pipe(
              take(1),
              tap(url => this.attachmentsService.downloadAttachment(url))
            )
            .subscribe();
        },
      },
      {
        icon: 'delete',
        tooltipKey: 'Grid.Delete',
        disabled: true,
        clickFn: (event: DvToolbarActionEvent) => {
          deleteFileFn(event);
        },
      },
      {
        icon: 'add_box',
        clickFn: uploadFileFn,
        disabled: false,
        tooltipKey: 'Grid.Add',
      },
    ];
  }
}
